import React from 'react'
import styled from "styled-components"

const Container=styled.div`
    height: 30px;
    background-color: #aef3f3;
    color:black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
`

const Announcement = () => {
  return (
    <Container>
        Super Deal! Free Shipping on Orders over 50k
    </Container>
  )
}

export default Announcement